<template>
  <div class="tr-step-4">
    <div class="tr-step-4__card">
      <div class="tr-step-4__mainHead">
        <v-icon>mdi-home-roof</v-icon>

        STEP:4 Roof & Wall Assembly Details
      </div>
      <div class="tr-step-4__subHead">(A) Roof</div>

      <div>
        <ThermalTransRoofTable5A />
      </div>
      <div class="step-4__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step4' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step5B' })">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ThermalTransRoofTable5A from '../tables/step5A/ThermalTransRoofTable5A.vue';

export default {
  components: {
    ThermalTransRoofTable5A,
  },
  data() {
    return {
      Steps4: ['Openable window-to-floor area ratio (WFRop)', 'Visible Light Transmittance'],
    };
  },
};
</script>

<style lang="scss">
.tr-step-4 {
  padding: 32px;
  width: 100%;
  height: 100%;
}

.tr-step-4__card {
  background-color: #fff;
  padding: 38px;
  // width: 80%;
}
.tr-step-4__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.tr-step-4__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}
.step-4__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step-4__next-back-row {
  padding: 16px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}
</style>
